
import React from 'react';
import { sections } from './config/cycleConfig';
import { CycleSectionComponent } from './components/CycleSection';
import { DayNumber } from './components/DayNumber';
import { CenterText } from './components/CenterText';
import { CurrentDayIndicator } from './components/CurrentDayIndicator';
import { calculatePhase, calculateCurrentDay } from './utils/cycleCalculations';

interface CycleChartProps {
  lastPeriodDate?: Date;
  cycleLength?: string;
}

const CycleChart = ({ lastPeriodDate, cycleLength }: CycleChartProps) => {
  const center = { x: 200, y: 200 };

  console.log('CycleChart props:', { 
    lastPeriodDate: lastPeriodDate?.toISOString(), 
    cycleLength,
    isLastPeriodDateValid: lastPeriodDate instanceof Date && !isNaN(lastPeriodDate.getTime()),
    isCycleLengthValid: !!cycleLength && !isNaN(parseInt(cycleLength))
  });

  const showCurrentDay = lastPeriodDate instanceof Date && 
    !isNaN(lastPeriodDate.getTime()) && 
    !!cycleLength && 
    !isNaN(parseInt(cycleLength));

  const currentPhase = showCurrentDay && lastPeriodDate && cycleLength 
    ? calculatePhase(lastPeriodDate, cycleLength, "5") // Using default period duration
    : null;

  const currentDay = showCurrentDay && lastPeriodDate && cycleLength
    ? calculateCurrentDay(lastPeriodDate, cycleLength)
    : null;

  return (
    <div className="w-full max-w-lg mx-auto p-1">
      <svg viewBox="0 0 400 400" className="w-full h-full max-h-[350px] overflow-visible">
        {/* Background circle */}
        <circle 
          cx={center.x} 
          cy={center.y} 
          r={sections.radii.outerBlue} 
          fill="white"
        />
        
        {/* Outer border */}
        <circle 
          cx={center.x} 
          cy={center.y} 
          r={sections.radii.outerBlue} 
          fill="none" 
          stroke="#4682B4" 
          strokeWidth="10"
        />

        {/* Colored sections with labels */}
        {sections.outer.map((section, idx) => (
          <CycleSectionComponent
            key={idx}
            section={section}
            idx={idx}
            center={center}
          />
        ))}

        {/* Day numbers */}
        {Array.from({ length: 28 }, (_, i) => (
          <DayNumber 
            key={i} 
            day={i + 1} 
            center={center}
            currentPhase={currentPhase}
            isCurrentDay={currentDay === i + 1}
          />
        ))}

        {/* Current day indicator */}
        {showCurrentDay && currentDay && (
          <CurrentDayIndicator
            center={center}
            lastPeriodDate={lastPeriodDate}
            cycleLength={parseInt(cycleLength)}
          />
        )}

        {/* Center text */}
        <CenterText center={center} />
      </svg>

      {/* Legend */}
      <div className="mt-4 grid grid-cols-2 gap-2 text-sm">
        {sections.outer.map((section, idx) => (
          <div key={`legend-${idx}`} className="flex items-center gap-2">
            <div 
              className="w-4 h-4 rounded-full" 
              style={{ backgroundColor: section.color }}
            />
            <span className="text-gray-700">{section.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CycleChart;
